<template>
  <div id="barra-superior">
    <img src="../assets/upc-positiu-p3005.png" class="logo" alt="LogoUPC" />

      <div id="colors-pane">
      <h2
        v-on:click="overcolors = !overcolors"
        class="top-dropper unselectable"
      >
        {{ $t("Layers") }}
      </h2>
      <div id="colors-container" v-cloak v-if="overcolors">
        <!-- aixo es per amagar l'ombra xdddd-->

        <div v-for="(values, disc) in this.disciplines" v-bind:key="disc">
          <input
            :id="disc"
            type="checkbox"
            :value="disc"
            :disabled="$store.getters.heat_map"
            v-model="checkedValues"
            style="cursor: pointer"
            @change ="updateDisciplinesMarcades"
          />
          <label
            :for="disc"
            class="unselectable"
            style="display: block; margin-left: 1.5em; margin-top: -20px; cursor: pointer;"
          >
            <div
              :style="{
                backgroundColor: values,
                display: 'inline-block',
                margin: '0px 0px -3px 0px',
                width: '0.9em',
                height: '0.9em',
                cursor: 'pointer'
              }"
            ></div>
            {{ disc }}
          </label>
        </div>
      </div>
    </div>

      <div id="help-pane">
      <h2
        v-on:click="showhelp = !showhelp"
        class="top-dropper unselectable"
      >
        {{ $t("Help") }}
      </h2>
      <div id="help-container" v-cloak v-if="showhelp">
        <vue-custom-scrollbar class="scroll-area"  >
          <h3>
            {{ $t("What is ATLAS?") }}
          </h3>
          <p>
              {{ $t("ATLAS is a decision-making tool that allows to describe existing disciplines, show emerging areas and detect areas of disciplinary convergence") }}.        </p>
          <h3>
              {{ $t("What is a node ?") }}
          </h3>
          <p>
              {{ $t("Each node represents a scientific publication from one or more UPC research areas") }}.
          </p>
          <h3>
              {{ $t("What is an edge ?") }}
          </h3>
          <p>
              {{ $t("Each edge represents the connection between two nodes that have in common a set of relevant words") }}.
          </p>
          <h3>
              {{ $t("What are layers ?") }}
          </h3>
          <p>
              {{ $t("Each layer allows you to view documents that have a specific SCOPUS tag") }}.
          </p>
          <h3>
              {{ $t("What is a node cluster ?") }}
          </h3>
          <p>
              {{ $t("A cluster is a set of publications with similar themes that share a close position in an n - vector space") }}.
          </p>
          <h3>
              {{ $t("What is the Non - clustered cluster ?") }}
          </h3>
          <p>
              {{ $t("The Non-clustered cluster groups all the remaining publications in the corpus that are not close enough to any cluster to be part of it") }}.
          </p>
          <h3>
              {{ $t("What is the Growth map ?") }}
          </h3>
          <p>
              {{ $t("The Growth Map allows you to graphically visualize the areas where more publications have been made in recent years") }}.
          </p>
          <h3>
              {{ $t("How does the Search Bar work ?") }}
          </h3>
          <p>
            {{ $t("In the top bar you can search for words or authors. Words start with a lowercase letter and authors with a capital letter") }}.
          </p>
        </vue-custom-scrollbar>
      </div>
    </div>
      <LanguageSelector></LanguageSelector>

  </div>
</template>
<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import LanguageSelector from "@/components/LanguageSelector"
export default {
  components: {
    vueCustomScrollbar,
      LanguageSelector,
  },
  name: "BarraSuperior",
  data() {
    return {
      disciplines: {},
      checkedValues: [],
      filters: {},
      overcolors: false,
      overclusters: false,
      disc_hex: {},
      clusters: [],
      disciplines_marcades: [],
      showhelp: false,
    };
  },
  beforeCreate() {
    this.$store.dispatch("Activa_loader");
    this.$store.dispatch("inicialitza");
  },

  mounted() {
      this.disciplines = this.$store.getters.disciplines
      this.disc_hex = this.$store.getters.disc_hex
  },

  methods: {
    updateDisciplinesMarcades: function (e) {

      let a = false;
      for(let i=0; i<this.disciplines_marcades.length; i++){
        if(this.disciplines_marcades[i] == e.target.id){
          a=true;
          this.disciplines_marcades.splice(i, 1);

        }
      }
      if(!a){
        this.disciplines_marcades.push(e.target.id);

      }
      console.log(this.disciplines_marcades)
      this.$store.dispatch("MarcarDisciplines", this.disciplines_marcades);
    },

  },
};
</script>
<style scoped>
.unselectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}


#barra-superior {
  font-variant: small-caps;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: auto;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
.logo {
  height: 4em;
  position: relative;
}

.line {
  clear: both;
  display: block;
  width: 100%;
  border-bottom: 1px solid var(--blueupc);
  background: transparent;
  position: relative;
}
.hidden {
  display: none;
  visibility: hidden;
}
[v-cloak] {
  display: none;
}

#colors-pane {
  height: 4em;
  right: 22em;
  position: absolute;
  z-index: 1;
  width: 16em;
  background-color: white;
  z-index: 5;
}



#colors-container {
  background-color: white;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);
  padding: 0.5em;
  margin-right: 0.1em;
}

#help-pane {
  height: 4em;
  right: 4em;
  position: absolute;
  z-index: 1;
  width: 18em;
  background-color: white;
  z-index: 5;
}
h3{
  line-height: 1em;
}
p{
  text-align: justify;
  font-variant: normal;
  font-size: 14px;
  font-family: Helvetica, Arial, sans-serif;
  color: #0077C8;
  line-height: 1;
}
#help-container{
  background-color: white;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);
  padding: 0.5em;
  display: block;
  margin-left: 0.1em;
}

input[type="range"] {
  width: 60%;
  height: 0.1em;
  margin: auto;
  color: var(--blueupc);
}
.top-dropper {
  text-align: center;
  margin: 0;
  padding-top: 15px;
  padding-bottom: 15px;
  background: white;
}
.top-dropper:hover {
  background: rgb(230,230,230);
  cursor: pointer;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

#language-selector {
    height: 2em;
    right: 1em;
    position: absolute;
    z-index: 1;
    width: 3em;
    background-color: white;
    z-index: 5;
}
</style>
